
// export const apiBaseUrl = 'https://mabesha.webcreatore.com/admin/';
export const apiBaseUrl = 'https://mabesha.com/admin/';
export const testBaseUrl = 'https://mabesha.webcreatore.com/admin/';
